import { SetState } from 'zustand';
import { StoreState } from './index';

export type ChatSlice = {
  isChatActive: boolean;
  activateChat: () => void;
  deactivateChat: () => void;
};

export const chatSlice = (set: SetState<StoreState>) => ({
  // The slice declared this but never seeded it, so it read `undefined` until
  // the first `activateChat`. Both are falsy; nothing reads it today.
  isChatActive: false,
  activateChat: () => {
    set(() => ({ isChatActive: true }));
  },
  deactivateChat: () => {
    set(() => ({ isChatActive: false }));
  },
});

export const activateChatSelector = (state: StoreState) => state.activateChat;
